<template>
  <div>
    <div
      :class="
        $mq == 'miniMobilePhones'
          ? 'table-width-miniPhones'
          : isExtension
          ? 'table-width-extension d-flex justify-center align-center'
          : $vuetify.breakpoint.md
          ? 'table-width-2'
          : $vuetify.breakpoint.sm
          ? 'table-width-3'
          : $vuetify.breakpoint.xs
          ? 'table-width-miniPhones'
          : getSidebarMini
          ? 'table-width-4'
          : 'table-width'
      "
    >
      <div style="position: relative">
        <v-overlay
          :class="
            isExtension
              ? 'table-width-extension'
              : $vuetify.breakpoint.md
              ? 'table-width-2 overlay-height'
              : $vuetify.breakpoint.xs || $vuetify.breakpoint.sm
              ? 'table-width-3 overlay-height-sm'
              : getSidebarMini
              ? 'test-width  overlay-height'
              : 'test-width  overlay-height'
          "
          absolute
          id="divOverlay"
          :value="!getOnlineStatus"
          v-if="!getOnlineStatus"
          color="white"
        >
        </v-overlay>
      </div>

      <div style="position: relative">
        <!-- Loader while waiting -->
        <v-skeleton-loader
          tile
          v-show="getTasksSkeletonLoader"
          type="table-tbody,table-tfoot"
          class="mt-3"
          :class="
            isExtension
              ? 'table-width-extension'
              : $vuetify.breakpoint.md
              ? 'table-width-2'
              : $vuetify.breakpoint.xs || $vuetify.breakpoint.sm
              ? 'table-width-3'
              : getSidebarMini
              ? 'table-width-4'
              : 'table-width'
          "
        >
        </v-skeleton-loader>
        <!-- Assigned to menu -->
        <v-menu
          v-model="assignedToMenu"
          absolute
          min-width="300"
          content-class="bg-white dropdown"
          :close-on-content-click="false"
          :position-x="x"
          :position-y="y"
          nudge-left="50"
          nudge-bottom="10"
          offset-y
        >
          <!-- member search-->
          <div :class="[{ edited_scrollbar: isMac }]">
            <!-- Search field -->
            <div class="search-border rounded ma-2">
              <v-text-field
                prepend-inner-icon="mdi-magnify"
                background-color="white"
                placeholder="Search..."
                class="body-2"
                color="#757096"
                hide-details
                solo
                flat
                dense
                autofocus
                v-model="memberSearch"
                autocomplete="off"
                @keydown.enter="
                  selectedItem != null
                    ? (newAddedMembers && newAddedMembers.length > 1) ||
                      filteredNonAssignees(selectedTask.task_id).find(
                        (item) => {
                          return item.id == filteredAllMembers[selectedItem].id;
                        }
                      )
                      ? addOrRemove(filteredAllMembers[selectedItem])
                      : () => {}
                    : selectedItem != null && memberSearch
                    ? (newAddedMembers && newAddedMembers.length > 1) ||
                      filteredNonAssignees(selectedTask.task_id).find(
                        (item) => {
                          return item.id == filteredAllMembers[selectedItem].id;
                        }
                      )
                      ? addOrRemove(filteredAllMembers[0])
                      : () => {}
                    : memberSearch && filteredAllMembers.length == 0
                    ? (dialog = true)
                    : ''
                "
                @keydown.up="selectPrev2"
                @keydown.down="selectNext2"
              >
              </v-text-field>
            </div>
            <v-list
              v-if="selectedTask"
              class="pointer overflow-scroll"
              scrollable
              max-height="170"
            >
              <div
                v-for="(member, index) in filteredAllMembers"
                :key="member.email"
                :disabled="
                  (getActiveTask && member.id == getLoggedInUser.id) ||
                  selectedTask.members.length <= 1
                    ? true
                    : false
                "
                class="d-flex listing-hover caption list-item-min-height"
                @click="
                  getActiveTask && getActiveTask.task_id == selectedTask.task_id
                    ? member.id != getLoggedInUser.id
                      ? (newAddedMembers && newAddedMembers.length > 1) ||
                        filteredNonAssignees(selectedTask.task_id).find(
                          (item) => {
                            return item.id == member.id;
                          }
                        )
                        ? addOrRemove(member)
                        : () => {}
                      : () => {}
                    : (newAddedMembers && newAddedMembers.length > 1) ||
                      filteredNonAssignees(selectedTask.task_id).find(
                        (item) => {
                          return item.id == member.id;
                        }
                      )
                    ? addOrRemove(member)
                    : () => {}
                "
                :class="
                  selectedItem == index
                    ? 'bg-hover'
                    : newAddedMembers &&
                      newAddedMembers.find((item) => {
                        return item == member.id;
                      })
                    ? 'bg-selected'
                    : ''
                "
              >
                <profileImage
                  v-show="member.image ? ':src' : ':username'"
                  :src="member.image"
                  inline
                  :username="member.name ? member.name : member.email"
                  :size="23"
                  :userProfile="true"
                  :circular="true"
                  class="ml-3 text-light"
                >
                </profileImage>
                <v-list-item-content
                  style="max-width: 160px"
                  class="d-inline-block text-truncate ml-3"
                  v-if="member.name"
                  >{{
                    getLoggedInUser.id == member.id
                      ? "ME"
                      : member.name[0].toUpperCase() +
                        member.name.slice(1).toLowerCase()
                  }}</v-list-item-content
                >
                <v-list-item-content
                  style="max-width: 160px"
                  class="d-inline-block text-truncate ml-3"
                  v-if="!member.name"
                  >{{ member.email }}</v-list-item-content
                >
                <v-spacer></v-spacer>
                <v-icon
                  v-show="
                    newAddedMembers &&
                    newAddedMembers.find((item) => {
                      return item == member.id;
                    })
                  "
                  small
                  class="mr-4"
                  color="#1cc283"
                  >mdi-check-box-outline</v-icon
                >
              </div>
              <div
                v-if="
                  memberSearch &&
                  !filteredAssignees(selectedTask.task_id).length &&
                  !filteredNonAssignees(selectedTask.task_id).length
                "
              >
                <p class="no-results-found my-1">No results found</p>
              </div>
            </v-list>
            <v-btn
              v-if="getSelectedCompany.role != 'employee'"
              @click="dialog = true"
              color="#EEF0F6"
              block
              tile
              depressed
              class="listing-hover text-capitalize dark-purple-text"
            >
              <v-icon size="16" class="mx-1">mdi-plus</v-icon>
              <span>Add New Member</span></v-btn
            >
          </div>
        </v-menu>
        <!-- Project Menu -->
        <v-menu
          :close-on-content-click="false"
          min-width="300"
          content-class="bg-white dropdown"
          offset-y
          v-model="projectMenu"
          absolute
          :position-x="x"
          :position-y="y"
          nudge-left="50"
          nudge-bottom="10"
        >
          <div v-if="selectedTask" :class="[{ edited_scrollbar: isMac }]">
            <!-- Search field -->
            <div class="search-border rounded ma-2">
              <v-text-field
                prepend-inner-icon="mdi-magnify"
                background-color="white"
                placeholder="Search..."
                class="body-2"
                color="#757096"
                hide-details
                solo
                flat
                dense
                autofocus
                autocomplete="off"
                v-model="projectSearch"
                @keydown.enter="
                  selectedItem != null
                    ? updateSelectedProject(
                        projectsList[selectedItem],
                        selectedTask
                      )
                    : selectedItem != null && projectSearch
                    ? updateSelectedProject(projectsList[0], selectedTask)
                    : projectSearch && projectsList.length == 0
                    ? createProject()
                    : ''
                "
                @keydown.up="selectPrev"
                @keydown.down="selectNext"
              >
              </v-text-field>
            </div>
            <v-list max-height="170" class="pointer overflow-scroll">
              <small
                v-if="!projectSearch && !getProjects.length"
                class="caption d-flex justify-center align-center"
              >
                Please enter the project name
              </small>
              <div
                v-for="(project, index) in projectsList"
                :key="project.id"
                class="listing-hover d-flex pointer list-item-min-height"
                :class="
                  selectedItem == index
                    ? 'bg-hover'
                    : selectedTask.project
                    ? selectedTask.project.id == project.id
                      ? 'bg-selected'
                      : projectSearch && index == 0
                      ? 'bg-search-result'
                      : ''
                    : ''
                "
              >
                <v-text-field
                  v-if="project.edit"
                  v-model="editProjectName"
                  dense
                  hide-details
                  color="#2a206a"
                  flat
                  solo
                  class="w-100 mx-3 caption theme-border"
                  autofocus
                  autocomplete="off"
                  @blur="
                    project.edit = false;
                    project.id != editIcon;
                  "
                >
                </v-text-field>

                <div
                  v-if="!project.edit"
                  @click="
                    selectedTask.project
                      ? selectedTask.project.id == project.id
                        ? updateSelectedProject(null, selectedTask)
                        : updateSelectedProject(project, selectedTask)
                      : updateSelectedProject(project, selectedTask)
                  "
                  class="d-flex align-center w-100"
                >
                  <div class="d-flex list-item-min-height">
                    <profileImage
                      inline
                      :username="project.name"
                      :size="23"
                      :circular="true"
                      class="ml-3 text-light"
                    >
                    </profileImage>
                    <v-list-item-content
                      ><span
                        style="max-width: 160px"
                        class="
                          ml-2
                          d-inline-block
                          text-truncate
                          w-12
                          caption
                          text-capitalize
                        "
                      >
                        {{ project.name }}
                      </span>
                    </v-list-item-content>
                  </div>
                </div>
                <v-spacer></v-spacer>
                <v-icon
                  small
                  color="#1cc283"
                  class="mr-3"
                  v-text="
                    selectedTask.project
                      ? selectedTask.project.id == project.id
                        ? 'mdi-check-box-outline'
                        : ''
                      : ''
                  "
                ></v-icon>
                <v-tooltip
                  :disabled="$vuetify.breakpoint.xs"
                  content-class="arrow-down"
                  top
                  color="#DCD8F3"
                >
                  <template v-slot:activator="{ on }">
                    <v-icon
                      v-on="on"
                      v-show="project.id == editIcon"
                      class="mr-1 dark-purple-text"
                      :class="
                        getSelectedCompany.role == 'team-manager' ||
                        getSelectedCompany.role == 'employee'
                          ? 'd-none'
                          : ''
                      "
                      @click="updateProject(project)"
                      small
                    >
                      mdi-check
                    </v-icon>
                  </template>
                  <span class="dark-purple-text font-weight-bold"
                    >Update Project</span
                  >
                </v-tooltip>
                <v-tooltip
                  :disabled="$vuetify.breakpoint.xs"
                  content-class="arrow-down"
                  top
                  color="#DCD8F3"
                >
                  <template v-slot:activator="{ on }">
                    <v-icon
                      v-on="on"
                      v-show="project.id != editIcon"
                      class="mr-1 dark-purple-text"
                      :class="
                        getSelectedCompany.role == 'team-manager' ||
                        getSelectedCompany.role == 'employee'
                          ? 'd-none'
                          : ''
                      "
                      @click="editProject(project)"
                      small
                    >
                      mdi-pencil
                    </v-icon>
                  </template>
                  <span class="dark-purple-text font-weight-bold"
                    >Edit Project</span
                  >
                </v-tooltip>
                <v-tooltip
                  :disabled="$vuetify.breakpoint.xs"
                  content-class="arrow-down"
                  top
                  color="#DCD8F3"
                >
                  <template v-slot:activator="{ on }">
                    <v-icon
                      v-on="on"
                      class="dark-purple-text mr-2"
                      @click="deleteProject(project)"
                      small
                      :class="
                        getSelectedCompany.role == 'team-manager' ||
                        getSelectedCompany.role == 'employee'
                          ? 'd-none'
                          : ''
                      "
                      >mdi-trash-can-outline</v-icon
                    >
                  </template>
                  <span class="dark-purple-text font-weight-bold"
                    >Delete Project</span
                  >
                </v-tooltip>
              </div>
              <div v-if="projectSearch && !projectsList.length">
                <p class="no-results-found my-1">No results found</p>
              </div>
            </v-list>
            <v-btn
              v-if="projectBtn"
              @click="projectSearch ? createProject() : (projectBtn = false)"
              color="#EEF0F6"
              block
              tile
              class="listing-hover text-capitalize"
              :class="
                !projectBtn ||
                getSelectedCompany.role == 'team-manager' ||
                getSelectedCompany.role == 'employee'
                  ? 'd-none'
                  : ''
              "
            >
              <v-icon size="16" class="mx-1">mdi-plus</v-icon>
              <span
                style="max-width: 160px"
                class="d-inline-block text-truncate"
              >
                Add

                {{ projectSearch ? projectSearch : "New Project" }}
              </span></v-btn
            >
            <v-text-field
              class="pa-0 ma-0 caption"
              v-if="!projectBtn"
              prepend-inner-icon="mdi-plus"
              color="#2a206a"
              background-color="#F8F7FD"
              hide-details
              autofocus
              v-model="searchProject"
              autocomplete="off"
              solo
              dense
              flat
              @keydown.enter="createProject()"
            >
              <template v-slot:append>
                <div class="font-size-10 pa-0 ma-0" color="#2a206a">
                  *press enter to add
                </div>
              </template>
            </v-text-field>
          </div>
        </v-menu>

        <!-- Priority Menu -->
        <v-menu
          v-model="priorityMenu"
          :close-on-content-click="false"
          content-class="bg-white"
          offset-y
          absolute
          :position-x="x"
          :position-y="y"
          nudge-left="50"
          nudge-bottom="10"
        >
          <div v-if="selectedTask" class="bg-white pointer py-2">
            <div
              v-for="(priority, i) in ['low', 'medium', 'high']"
              :key="i"
              :class="
                selectedTask.priority && selectedTask.priority == priority
                  ? 'bg-selected'
                  : ''
              "
              class="
                body-2
                listing-hover
                dark-purple-text
                d-flex
                align-center
                pr-5
                text-capitalize
                px-2
                py-1
              "
              @click="setPriority(selectedTask, priority)"
            >
              <span>{{ priority }}</span>
              <v-spacer></v-spacer>
              <v-icon
                v-visible="
                  selectedTask.priority && selectedTask.priority == priority
                "
                color="green"
                size="15"
                right
                >mdi-check-box-outline</v-icon
              >
            </div>
          </div>
        </v-menu>

        <!-- Due Date Menu -->
        <v-menu
          v-model="dueDateMenu"
          :close-on-content-click="false"
          content-class="bg-white"
          offset-y
          absolute
          :position-x="x"
          :position-y="y"
          nudge-left="50"
          nudge-bottom="10"
        >
          <v-date-picker
            id="task-page-due-date"
            v-if="selectedTask"
            v-model="date"
            color="#2a206a"
            @input="
              getPendingTimer && getPendingTimer.task_id == selectedTask.task_id
                ? () => {}
                : updateDueDate(date, selectedTask),
                (dateMenu = false)
            "
          >
            <v-spacer></v-spacer>
            <v-btn
              @click="
                getPendingTimer &&
                getPendingTimer.task_id == selectedTask.task_id
                  ? () => {}
                  : updateDueDate(null, selectedTask),
                  (dateMenu = false),
                  (selectedTask.due_date = null)
              "
              class="text-capitalize pointer caption"
              text
              color="#2a206a"
              outlined
            >
              Reset
            </v-btn>
          </v-date-picker>
        </v-menu>
        <v-data-table
          id="v-data-table-task"
          fixed-header
          :height="
            isExtension
              ? '70vh'
              : $vuetify.breakpoint.xs || $mq == 'xs'
              ? getSelectedCompany.role == 'employee'
                ? `calc(100vh - ${taskTableHeightExpSm}px - 20px)`
                : getActiveTask
                ? `calc(100vh - ${taskTableHeightExpSm}px - 20px)`
                : `calc(100vh - ${taskTableHeightExpSm}px)`
              : getSelectedCompany.role == 'employee'
              ? `calc(100vh - ${taskTableHeightExp}px - 20px)`
              : getActiveTask
              ? `calc(100vh - ${taskTableHeightExp}px - 20px)`
              : `calc(100vh - ${taskTableHeightExp - 10}px)`
          "
          v-show="!getTasksSkeletonLoader"
          :headers="headers"
          :loading="fetchLinearLoader || getTasksLinearLoaderState"
          loading-text="No data available"
          mobile-breakpoint="0"
          show-expand
          :items="
            getActiveTask
              ? [getActiveTask].concat(
                  getTasks.filter((item) => {
                    return item.task_id != getActiveTask.task_id;
                  })
                )
              : getTasks
          "
          :item-class="
            (item) => {
              return item.just_added
                ? 'teal--text font-weight-light teal lighten-5 elevation-3'
                : item.task_id == selection
                
                ? 'teal--text font-weight-light teal lighten-5 elevation-3'
                : item.is_flagged
                ? 'red lighten-5'
                : ''
            }
          "
          item-key="task_id"
          disable-pagination
          hide-default-footer
          :class="[
            { edited_scrollbar: isMac },
            $vuetify.breakpoint.xs || $mq == 'xs' ? ' mx-3' : 'mx-6',
            $mq == 'miniMobilePhones'
              ? 'table-width-miniPhones'
              : isExtension
              ? 'table-width-extension d-flex justify-center align-center'
              : $vuetify.breakpoint.md
              ? 'table-width-2'
              : $vuetify.breakpoint.sm
              ? 'table-width-3'
              : $vuetify.breakpoint.xs
              ? 'table-width-miniPhones'
              : getSidebarMini
              ? 'table-width-4'
              : 'table-width',
          ]"
          class="
            mb-0
            overflow-hidden
            table-border
            elevation-0
            mt-1
            transition-swing
            task-table
          "
          @click:row="rowClick"
        >
          <!-- Header Slot for Serial Number -->
          <template v-slot:[`header.sr_no`]="{ header }">
            <div class="dark-purple-text">
              {{ header.text }}
            </div>
          </template>
          <!-- Header Slot for Title -->
          <template v-slot:[`header.title`]="{ header }">
            <div class="dark-purple-text">
              {{ header.text }}
              <v-icon
                small
                color="#2a206a"
                class="pointer"
                @click="
                  sortByProject == 'desc'
                    ? (sortColumn('project', 'asc'), (sortByProject = 'asc'))
                    : (sortColumn('project', 'desc'), (sortByProject = 'desc'))
                "
              >
                {{
                  sortByProject == "asc" ? " mdi-arrow-up" : " mdi-arrow-down"
                }}</v-icon
              >
            </div>
          </template>
          <!-- Header Slot for Assigned By -->
          <template v-slot:[`header.assigned_by`]="{ header }">
            <div
              v-show="
                getSelectedCompany.role == 'owner' ||
                getSelectedCompany.role == 'admin' ||
                getSelectedCompany.role == 'team-manager' ||
                getSelectedCompany.role == 'employee'
              "
              class="dark-purple-text"
            >
              {{ header.text }}
            </div>
          </template>
          <!-- Header Slot for Assigned To -->
          <template v-slot:[`header.members`]="{ header }">
            <div
              v-show="
                getSelectedCompany.role == 'owner' ||
                getSelectedCompany.role == 'admin' ||
                getSelectedCompany.role == 'team-manager' ||
                getSelectedCompany.role == 'employee'
              "
              class="dark-purple-text"
            >
              {{ header.text }}
            </div>
          </template>

          <!-- Header Slot Status -->
          <template v-slot:[`header.status`]="{ header }">
            <div class="dark-purple-text">
              {{ header.text }}
              <v-icon
                small
                color="#2a206a"
                class="pointer"
                @click="
                  sortByStatus == 'desc'
                    ? (sortColumn('status', 'asc'), (sortByStatus = 'asc'))
                    : (sortColumn('status', 'desc'), (sortByStatus = 'desc'))
                "
              >
                {{
                  sortByStatus == "asc" ? " mdi-arrow-up" : " mdi-arrow-down"
                }}</v-icon
              >
            </div>
          </template>

          <!-- Header Slot for Priority -->
          <template v-slot:[`header.priority`]="{ header }">
            <div class="dark-purple-text">
              {{ header.text }}
              <v-icon
                small
                color="#2a206a"
                class="pointer"
                @click="
                  sortByPriority == 'desc'
                    ? (sortColumn('priority', 'asc'), (sortByPriority = 'asc'))
                    : (sortColumn('priority', 'desc'),
                      (sortByPriority = 'desc'))
                "
              >
                {{
                  sortByPriority == "asc" ? " mdi-arrow-up" : " mdi-arrow-down"
                }}</v-icon
              >
            </div>
          </template>

          <!-- Header Slot for Project -->
          <template v-slot:[`header.project`]="{ header }">
            <div class="dark-purple-text">
              {{ header.text }}
              <v-icon
                small
                color="#2a206a"
                class="pointer"
                @click="
                  sortProjects == 'desc'
                    ? ((sortProjects = 'asc'),
                      sortColumn(header.value, sortProjects))
                    : ((sortProjects = 'desc'),
                      sortColumn(header.value, sortProjects))
                "
              >
                {{
                  sortProjects == "asc" ? " mdi-arrow-up" : " mdi-arrow-down"
                }}</v-icon
              >
            </div>
          </template>
          <!-- Header Slot for Assigned Date -->
          <template v-slot:[`header.created_at`]="{ header }">
            <div class="dark-purple-text">
              {{ header.text }}
              <v-icon
                small
                color="#2a206a"
                class="pointer"
                @click="
                  sortAssignedDate == 'desc'
                    ? ((sortAssignedDate = 'asc'),
                      sortColumn(header.value, sortAssignedDate))
                    : ((sortAssignedDate = 'desc'),
                      sortColumn(header.value, sortAssignedDate))
                "
              >
                {{
                  sortAssignedDate == "asc"
                    ? " mdi-arrow-up"
                    : " mdi-arrow-down"
                }}</v-icon
              >
            </div>
          </template>
          <!-- Header Slot for Edit Date -->
          <template v-slot:[`header.added_at`]="{ header }">
            <div class="dark-purple-text">
              {{ header.text }}
              <v-icon
                small
                color="#2a206a"
                class="pointer"
                @click="
                  sortAssignedDate == 'desc'
                    ? ((sortAssignedDate = 'asc'),
                      sortColumn(header.value, sortAssignedDate))
                    : ((sortAssignedDate = 'desc'),
                      sortColumn(header.value, sortAssignedDate))
                "
              >
                {{
                  sortAssignedDate == "asc"
                    ? " mdi-arrow-up"
                    : " mdi-arrow-down"
                }}</v-icon
              >
            </div>
          </template>
          <!-- Header Slot for Due Date -->
          <template v-slot:[`header.due_date`]="{ header }">
            <div class="dark-purple-text">
              {{ header.text }}
              <v-icon
                small
                color="#2a206a"
                class="pointer"
                @click="
                  sortDueDate == 'desc'
                    ? ((sortDueDate = 'asc'),
                      sortColumn(header.value, sortDueDate))
                    : ((sortDueDate = 'desc'),
                      sortColumn(header.value, sortDueDate))
                "
              >
                {{
                  sortDueDate == "asc" ? " mdi-arrow-up" : " mdi-arrow-down"
                }}</v-icon
              >
            </div>
          </template>
          <!-- Header Slot for durations -->
          <template v-slot:[`header.members.duration`]="{ header }">
            <div class="dark-purple-text">
              {{ header.text }}
              <v-icon
                small
                color="#2a206a"
                class="pointer"
                @click="
                  sortByDuration == 'desc'
                    ? (sortColumn('duration', 'asc'), (sortByDuration = 'asc'))
                    : (sortColumn('duration', 'desc'),
                      (sortByDuration = 'desc'))
                "
              >
                {{
                  sortByDuration == "asc" ? " mdi-arrow-up" : " mdi-arrow-down"
                }}</v-icon
              >
            </div>
          </template>
          <!-- Header Slot for actions -->
          <template v-slot:[`header.actions`]="{ header }">
            <div
              v-if="!isExtension"
              class="dark-purple-text d-flex align-center justify-end pr-6"
            >
              {{ header.text }}
              <v-tooltip
                :disabled="$vuetify.breakpoint.xs"
                color="#DCD8F3"
                content-class="arrow-up"
                bottom
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    color="#2a2620"
                    class="mx-1 pointer"
                    small
                    v-bind="attrs"
                    v-on="on"
                    @click="
                      sortByComments == 'desc'
                        ? (sortColumn('comment_count', 'asc'),
                          (sortByComments = 'asc'))
                        : (sortColumn('comment_count', 'desc'),
                          (sortByComments = 'desc'))
                    "
                    >{{
                      sortByComments == "asc"
                        ? " mdi-arrow-up"
                        : " mdi-arrow-down"
                    }}</v-icon
                  >
                </template>
                <span class="dark-purple-text font-weight-bold"
                  >Sort by Comments</span
                >
              </v-tooltip>
            </div>
          </template>
          <v-progress-linear
            v-show="fetchLinearLoader || getTasksLinearLoaderState"
            slot="progress"
            color="#2a206a"
            indeterminate
          ></v-progress-linear>
          <!-------------------------------->
          <!-- Item Slots -->
          <!-- Icon for expanding -->
          <template
            v-slot:[`item.data-table-expand`]="{ expand, isExpanded, item }"
          >
            <div style="min-width: 40px" class="d-flex align-center">
              <v-btn
                class="px-0"
                :class="[{ 'mr-2': isExtension }]"
                :style="
                  item.interval.length
                    ? { visibility: 'visible' }
                    : { visibility: 'hidden' }
                "
                icon
                x-small
                @click.stop="
                  expandedTask = item;
                  expand(!isExpanded);
                "
              >
                <v-icon>{{
                  !isExpanded ? "mdi-chevron-right" : "mdi-chevron-down"
                }}</v-icon>
              </v-btn>
              <!-- play/pause icon div -->
              <div
                v-if="
                  item.members.find((item) => {
                    return item.id == getLoggedInUser.id;
                  })
                "
              >
                <v-tooltip
                  :disabled="$vuetify.breakpoint.xs"
                  content-class="arrow-up"
                  bottom
                  color="#DCD8F3"
                >
                  <template v-slot:activator="{ on }">
                    <v-icon
                      color="#1cc283"
                      class="my-1"
                      v-on="on"
                      :class="
                        getActiveTask && getActiveTask.task_id == item.task_id
                          ? 'stop-icon'
                          : 'play-icon'
                      "
                      @click.stop="
                        getActiveTask && getActiveTask.task_id == item.task_id
                          ? stopTask()
                          : playTask(item)
                      "
                      >{{
                        getActiveTask && getActiveTask.task_id == item.task_id
                          ? "mdi-pause-circle-outline"
                          : "mdi-play-circle-outline"
                      }}</v-icon
                    >
                  </template>
                  <span class="dark-purple-text font-weight-bold">{{
                    getActiveTask && getActiveTask.task_id == item.task_id
                      ? "Stop Task"
                      : "Play Task"
                  }}</span>
                </v-tooltip>
              </div>
            </div>
          </template>
          <!-- Intervals -->
          <template v-slot:expanded-item="{ item }">
            <td
              v-show="item.interval.length"
              :class="{
                'ma-0 pa-0': true,
              }"
              class="pa-0 border-0 white"
              colspan="12"
            >
              <!-- Child Table -->
              <TaskEntries
                :headers="
                  headers
                    .slice(0, 7)
                    .concat([
                      {
                        value: 'interval',
                        text: 'Start  -  End Time',
                        width: '116px',
                        sortable: false,
                        class: 'light-purple-bg pl-0 pr-3',
                        cellClass: 'px-1',
                      },
                    ])
                    .concat(headers.slice(7))
                "
                :expandedTask="item"
              />
            </td>
          </template>
          <!-- Item Slot for Serial Number -->
          <template v-slot:[`item.sr_no`]="{ item }">
            <div>
              <v-tooltip
                :disabled="$vuetify.breakpoint.xs"
                style="min-width: 80px"
                color="#DCD8F3"
                content-class="arrow-up"
                bottom
              >
                <template v-slot:activator="{ on, attrs }">
                  <div
                    v-on="on"
                    v-bind="attrs"
                    class="serial pointer"
                    @click.stop="copySerialNumber(item.sr_no)"
                  >
                    {{ item.sr_no ? "#" + item.sr_no : " " }}
                  </div>
                </template>
                <span
                  class="dark-purple-text font-weight-bold"
                  v-if="copiedSerialNumber != item.sr_no"
                  >Copy to clipboard</span
                >
                <span
                  class="dark-purple-text font-weight-bold"
                  v-else-if="copiedSerialNumber == item.sr_no"
                  >Copied</span
                >
              </v-tooltip>
            </div>
          </template>
          <!-- Task Title & Project -->
          <template v-slot:[`item.title`]="{ item }">
            <!-- Labels -->
            <div>
              <span v-for="(label, index) in item.labels" :key="index">
                <v-chip
                  v-if="
                    getAllLabels.find((item) => {
                      return item.id == label;
                    }) && index < 4
                  "
                  class="mr-1 pointer"
                  label
                  :style="
                    showLabelName
                      ? 'height:20px;border-radius:2px;max-width: 100px;font-size:12px'
                      : 'height:8px;width:40px'
                  "
                  x-small
                  :color="
                    getAllLabels.find((element) => {
                      return element.id == label;
                    }).hexcode
                  "
                  @click.stop="
                    showLabelName == null
                      ? (showLabelName = item)
                      : (showLabelName = null)
                  "
                >
                  <span
                    class="
                      text-truncate
                      d-inline-block
                      white--text
                      text-capitalize
                      font-weight-bold
                    "
                    style="max-width: 140px"
                  >
                    {{
                      showLabelName
                        ? getAllLabels.find((element) => {
                            return element.id == label;
                          }).title
                        : ""
                    }}
                  </span>
                </v-chip>
              </span>
              <v-tooltip
                content-class="white pa-0 tooltip-opacity"
                bottom
                v-if="item && item.labels && item.labels.length > 4"
              >
                <template v-slot:activator="{ on, attrs }">
                  <div class="d-inline-block" v-on="on" v-bind="attrs">
                    <span
                      class="font-size-10 dusty-purple-text"
                      v-if="!$vuetify.breakpoint.xs"
                    >
                      (+{{ item.labels.length - 4 }} more)
                    </span>
                  </div>
                </template>
                <span :class="isMac ? 'edited_scrollbar' : ''">
                  <v-card
                    max-width="300px"
                    max-height="200px"
                    class="y-scroll shadow"
                  >
                    <v-card-text>
                      <span v-for="(label, index) in item.labels" :key="index">
                        <v-chip
                          v-if="
                            getAllLabels.find((item) => {
                              return item.id == label;
                            })
                          "
                          class="mr-1 mb-1 pointer"
                          label
                          style="'height:20px;border-radius:2px;max-width: 140px;font-size:12px'
                    "
                          x-small
                          :color="
                            getAllLabels.find((element) => {
                              return element.id == label;
                            }).hexcode
                          "
                        >
                          <span
                            class="
                              text-truncate
                              d-inline-block
                              white--text
                              text-capitalize
                              font-weight-bold
                            "
                            style="max-width: 140px"
                          >
                            {{
                              getAllLabels.find((element) => {
                                return element.id == label;
                              }).title
                            }}
                          </span>
                        </v-chip>
                      </span>
                    </v-card-text>
                  </v-card>
                </span>
              </v-tooltip>
            </div>
            <!-- Project -->
            <div class="d-flex pointer">
              <!-- Employee case -->
              <v-tooltip
                :disabled="$vuetify.breakpoint.xs"
                v-if="
                  item.assigned_by.id != getLoggedInUser.id &&
                  getSelectedCompany.role == 'employee'
                "
                content-class="arrow-up"
                bottom
                color="#DCD8F3"
              >
                <template v-slot:activator="{ on }">
                  <div
                    v-on="on"
                    height="22px"
                    class="
                      align-self-end
                      pa-0
                      d-flex
                      dark-purple-text-btn
                      justify-start
                    "
                  >
                    <v-icon
                      v-show="item.project"
                      small
                      color="#322583"
                      class="mx-0 pa-0"
                      >mdi-circle-medium</v-icon
                    >
                    <span
                      class="text-capitalize dark-purple-text-btn text-truncate"
                      :class="[
                        {
                          'grey--text font-italic': !item.project,
                        },
                        item.assigned_by.id != getLoggedInUser.id &&
                        getSelectedCompany.role == 'employee'
                          ? ''
                          : 'project-name-on-hover red--text',
                      ]"
                      style="max-width: 350px; font-size: 0.96rem"
                      >{{
                        item.project ? item.project.name : "No Project"
                      }}</span
                    >
                  </div>
                </template>
                <span
                  class="dark-purple-text font-weight-bold text-capitalize pa-0"
                  >{{
                    item.project
                      ? item.project.name
                      : getSelectedCompany.role == "employee"
                      ? "No project"
                      : "Add Project"
                  }}</span
                >
              </v-tooltip>
              <!-- !Employee case -->
              <div
                @click.stop="
                  getPendingTimer && getPendingTimer.task_id == item.task_id
                    ? () => {}
                    : openProjectMenu($event, item)
                "
                v-else
                style="height: 22px"
                class="
                  align-self-end
                  pa-0
                  d-flex
                  font-weight-bold
                  justify-start
                  align-center
                "
              >
                <v-icon small v-show="!item.project" class="green--text mr-1">
                  mdi-plus-circle-outline
                </v-icon>
                <v-tooltip
                  :disabled="$vuetify.breakpoint.xs"
                  bottom
                  color="#DCD8F3"
                  content-class="arrow-up"
                >
                  <template v-slot:activator="{ on }">
                    <div v-on="on" class="d-flex align center">
                      <v-icon
                        v-if="item.project"
                        small
                        color="#322583"
                        class="mx-0 pa-0"
                        >mdi-circle-medium</v-icon
                      >
                      <span
                        @click="
                          editIcon = false;
                          projectBtn = true;
                          projectSearch = null;
                          searchProject = null;
                        "
                        class="
                          text-capitalize
                          pa-0
                          d-inline-block
                          text-truncate
                        "
                        :class="
                          item.project
                            ? 'dark-purple-text-btn project-name-on-hover'
                            : 'green--text'
                        "
                        style="max-width: 350px; font-size: 0.96rem"
                        >{{
                          item.project ? item.project.name : "Project"
                        }}</span
                      >
                    </div>
                  </template>
                  <span
                    class="
                      dark-purple-text
                      font-weight-bold
                      text-capitalize
                      pa-0
                    "
                    >{{
                      item.project ? item.project.name : "Add Project"
                    }}</span
                  >
                </v-tooltip>
              </div>
            </div>
            <!-- Title -->
            <v-hover v-slot="{ hover }">
              <div
                class="d-flex ml-4 d-inline-block align-center"
                :id="'title-' + item.task_id"
                style="min-width: 360px; max-width: 380px"
              >
                <v-icon
                  @click.stop="
                    selectTask(item);
                    taskTitle = item.title;
                    editingTitle = !editingTitle;
                  "
                  v-show="
                    hover &&
                    !taskTitle &&
                    !editingTitle &&
                    (item.assigned_by.id == getLoggedInUser.id ||
                      getSelectedCompany.role != 'employee')
                  "
                  size="14"
                  >mdi-pencil</v-icon
                >
                <v-text-field
                  autocomplete="off"
                  autofocus
                  class="title-border rounded elevation-0 pl-2 ma-0 body-2"
                  v-model="taskTitle"
                  dense
                  flat
                  hide-details=""
                  color="#757096"
                  placeholder="Add Title"
                  v-if="
                    selectedTask &&
                    editingTitle &&
                    selectedTask.task_id == item.task_id &&
                    (getSelectedCompany.role != 'employee' ||
                      item.assigned_by.id == getLoggedInUser.id)
                  "
                  @click.stop=""
                  @keydown.enter="editTaskTitle(item)"
                  @blur="selectedTask = null"
                  @keydown.esc="selectedTask = null"
                >
                  <template v-slot:append>
                    <v-icon color="green" @click.stop="editTaskTitle(item)">
                      mdi-check
                    </v-icon>
                  </template>
                </v-text-field>

                <p
                  v-else
                  :class="[
                    { 'thin red--text font-italic': !item.title },
                    item.assigned_by.id != getLoggedInUser.id &&
                    getSelectedCompany.role == 'employee'
                      ? ''
                      : 'pointer',
                  ]"
                  class="d-flex align-center ma-0"
                >
                  <v-tooltip
                    :disabled="$vuetify.breakpoint.xs"
                    open-delay="150"
                    content-class="arrow-up"
                    bottom
                    color="#DCD8F3"
                  >
                    <template v-slot:activator="{ on }">
                      <p
                        v-line-clamp:20="2"
                        class="title-font text-capitalize"
                        :class="hover ? 'ml-1' : ''"
                        v-on="on"
                        style="
                          word-wrap: break-word !important;
                          word-break: break-word !important;
                        "
                      >
                        {{ item.title ? item.title : "no title" }}
                      </p>
                    </template>
                    <span
                      class="
                        d-inline-block
                        text-capitalize
                        dark-purple-text
                        font-weight-bold
                      "
                      style="max-width: 600px"
                      :style="
                        $vuetify.breakpoint.xs || $vuetify.breakpoint.sm
                          ? 'word-wrap:break-word;'
                          : 'word-wrap:break-word;'
                      "
                    >
                      <p class="body-2 font-weight-bold dark-purple-text">
                        {{ item.title ? item.title : "no title" }}
                      </p>
                    </span>
                  </v-tooltip>
                </p>
              </div>
            </v-hover>
          </template>
          <!-- Assigned to -->
          <template v-slot:[`item.members`]="{ item }">
            <div
              class="align-center d-flex justify-center pa-0"
              v-if="
                getSelectedCompany.role == 'owner' ||
                getSelectedCompany.role == 'admin' ||
                getSelectedCompany.role == 'team-manager' ||
                getSelectedCompany.role == 'employee'
              "
              @click="
                getPendingTimer && getPendingTimer.task_id == item.task_id
                  ? () => {}
                  : openAssignedToMenu($event, item)
              "
            >
              <div v-if="item.members.length" class="transparent">
                <div
                  class="d-flex text-truncate align-center pointer"
                  v-for="member in item.members.slice(0, 1)"
                  @click="memberSearch = null"
                  :key="member.email"
                >
                  <v-tooltip
                    :disabled="$vuetify.breakpoint.xs"
                    content-class="ma-0 pa-0 tooltip-opacity"
                    right
                    open-delay="300"
                  >
                    <template v-slot:activator="{ on }">
                      <div class="d-flex" v-on="on">
                        <profileImage
                          v-show="member.image ? ':src' : ':username'"
                          :src="member.image"
                          :userProfile="true"
                          inline
                          :username="member.name ? member.name : member.email"
                          :size="30"
                          :circular="true"
                          class="text-light d-inline mr-2"
                        >
                        </profileImage>
                        <profileImage
                          v-if="
                            selectedTask && selectedTask.task_id == item.task_id
                              ? newAddedMembers.length > 1
                              : item.members.length > 1
                          "
                          inline
                          :username="`+${
                            selectedTask && selectedTask.task_id == item.task_id
                              ? newAddedMembers.length - 1
                              : item.members.length - 1
                          }`"
                          :size="30"
                          :userProfile="true"
                          :circular="true"
                          class="text-light d-inline ml-n8 mr-2"
                        >
                        </profileImage>
                      </div>
                    </template>
                    <!-- Display User info on hover -->
                    <div v-if="getAllMembers">
                      <UserInfo
                        :image="member.image"
                        :name="member.name ? member.name : ''"
                        :email="member.email ? member.email : ''"
                        :role="
                          getAllMembers.find((user) => {
                            return user.id == member.id;
                          })
                            ? getAllMembers.find((user) => {
                                return user.id == member.id;
                              }).role
                            : ''
                        "
                        :designation="
                          getAllMembers.find((user) => {
                            return user.id == member.id;
                          })
                            ? getAllMembers.find((user) => {
                                return user.id == member.id;
                              }).designation
                            : ''
                        "
                      />
                    </div>
                  </v-tooltip>
                </div>
              </div>
              <div
                class="transparent d-flex align-center justify-center"
                v-else
              >
                <v-tooltip color="#DCD8F3" content-class="arrow-up" bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <div
                      v-on="on"
                      v-bind="attrs"
                      class="d-flex text-truncate align-center pointer"
                    >
                      <span
                        class="
                          empty-avatar
                          pointer
                          caption--text
                          d-inline-block d-flex
                          align-center
                          justify-center
                        "
                        ><v-icon color="#757096" x-small>mdi-plus</v-icon></span
                      >
                    </div>
                  </template>
                  <span
                    class="text-capitalize dark-purple-text font-weight-bold"
                    >add member</span
                  >
                </v-tooltip>
              </div>
            </div>
          </template>
          <!-- Assigned By -->
          <template v-slot:[`item.assigned_by`]="{ item }">
            <div
              v-if="
                getSelectedCompany.role == 'owner' ||
                getSelectedCompany.role == 'admin' ||
                getSelectedCompany.role == 'team-manager' ||
                getSelectedCompany.role == 'employee'
              "
              class="align-center d-flex justify-center pa-0"
            >
              <div class="align-center d-flex text-truncate">
                <v-tooltip
                  :disabled="$vuetify.breakpoint.xs"
                  content-class="ma-0 pa-0 tooltip-opacity"
                  open-delay="300"
                  right
                >
                  <template v-slot:activator="{ on }">
                    <div v-on="on">
                      <profileImage
                        v-show="item.assigned_by.image ? ':src' : ':username'"
                        :src="item.assigned_by.image"
                        inline
                        :username="item.assigned_by.name"
                        :size="30"
                        :userProfile="true"
                        :circular="true"
                        class="my-2 text-light d-inline"
                      >
                      </profileImage>
                    </div>
                  </template>
                  <!-- Display User info on hover -->
                  <div v-if="getAllMembers">
                    <UserInfo
                      :image="item.assigned_by.image"
                      :name="item.assigned_by.name"
                      :email="item.assigned_by.email"
                      :role="
                        getAllMembers.find((user) => {
                          return user.id == item.assigned_by.id;
                        })
                          ? getAllMembers.find((user) => {
                              return user.id == item.assigned_by.id;
                            }).role
                          : ''
                      "
                      :designation="
                        getAllMembers.find((user) => {
                          return user.id == item.assigned_by.id;
                        })
                          ? getAllMembers.find((user) => {
                              return user.id == item.assigned_by.id;
                            }).designation
                          : ''
                      "
                    />
                  </div>
                </v-tooltip>
              </div>
            </div>
          </template>
          <!-- Assigned Date -->
          <template v-slot:[`item.created_at`]="{ item }">
            <div
              class="
                text-caption
                pointer
                d-flex
                justify-center
                px-2
                align-center
              "
              v-if="item.created_at"
              style="min-width: 110px"
            >
              <v-tooltip
                :disabled="$vuetify.breakpoint.xs"
                content-class="arrow-up"
                bottom
                color="#DCD8F3"
              >
                <template v-slot:activator="{ on: tooltip }">
                  <span
                    style="max-width: 150px"
                    class="caption text-truncate d-inline-block"
                    color="primary"
                    dark
                    v-on="{ ...tooltip }"
                  >
                    {{ getAssignedDate(item.created_at) }}
                  </span>
                </template>
                <span class="dark-purple-text font-weight-bold">{{
                  getAssignedDateFormat(item.created_at)
                }}</span>
              </v-tooltip>
              <!-- Recurring -->
              <v-tooltip
                :disabled="$vuetify.breakpoint.xs"
                content-class="arrow-up"
                bottom
                color="#DCD8F3"
              >
                <template v-slot:activator="{ on }">
                  <v-icon
                    color="green"
                    class="ml-2"
                    size="16"
                    v-show="item.recurring_type"
                    v-on="on"
                    >mdi-cached
                  </v-icon>
                </template>
                <span class="dark-purple-text font-weight-bold"
                  >Repeating {{ item.recurring_type }}</span
                >
              </v-tooltip>
            </div>
          </template>

          <!-- Edit Date -->
          <template v-slot:[`item.added_at`]="{ item }">
            <div
              class="
                text-caption
                pointer
                d-flex
                justify-center
                px-2
                align-center
              "
              v-if="item.added_at"
              style="min-width: 110px"
            >
              <v-tooltip
                :disabled="$vuetify.breakpoint.xs"
                content-class="arrow-up"
                bottom
                color="#DCD8F3"
              >
                <template v-slot:activator="{ on: tooltip }">
                  <span
                    style="max-width: 150px"
                    class="caption text-truncate d-inline-block"
                    color="primary"
                    dark
                    v-on="{ ...tooltip }"
                  >
                    {{ getAssignedDate(item.added_at) }}
                  </span>
                </template>
                <span class="dark-purple-text font-weight-bold">{{
                  getAssignedDateFormat(item.added_at)
                }}</span>
              </v-tooltip>
            </div>
          </template>
          <!-- Due date -->
          <template v-slot:[`item.due_date`]="{ item }">
            <div
              style="min-width: 110px !important"
              class="d-flex align-center justify-center"
            >
              <div
                v-if="!item.due_date"
                @click="openDueDateMenu($event, item)"
                class="pointer d-flex align-center"
              >
                <v-icon
                  :class="
                    item.due_date === getCurrentDate()
                      ? 'yellow-chip'
                      : item.due_date === getTommorrowDate()
                      ? 'green-chip'
                      : item.due_date < getCurrentDate()
                      ? 'red-chip'
                      : !item.due_date
                      ? 'no-date'
                      : 'green-chip'
                  "
                  >mdi-calendar</v-icon
                >
                <span class="mx-1 grey--text font-italic caption"
                  >No Due Date</span
                >
              </div>
              <div
                v-else
                @click="openDueDateMenu($event, item)"
                class="text-caption"
                :class="
                  getSelectedCompany.role == 'employee' &&
                  item.assigned_by.id != getLoggedInUser.id
                    ? ''
                    : 'pointer'
                "
              >
                <v-tooltip
                  :disabled="$vuetify.breakpoint.xs"
                  content-class="arrow-up"
                  bottom
                  color="#DCD8F3"
                >
                  <template v-slot:activator="{ on: tooltip }">
                    <div v-on="{ ...tooltip }">
                      <span
                        class="blue-chip-text"
                        v-if="item.due_date === getCurrentDate()"
                      >
                        Today
                      </span>
                      <span
                        class="green-chip-text"
                        v-else-if="
                          item.due_date === getTommorrowDate(item.due_date)
                        "
                      >
                        Tomorrow
                      </span>
                      <span
                        class="green-chip-text"
                        v-else-if="item.due_date > getCurrentDate()"
                      >
                        {{ getDueDate(item.due_date) }}
                      </span>
                      <span
                        class="red-chip-text"
                        v-else-if="item.due_date < getCurrentDate()"
                      >
                        {{ getDueDate(item.due_date) }}
                      </span>
                    </div>
                  </template>
                  <span
                    class="dark-purple-text font-weight-bold"
                    style="width: 116px"
                    >{{ getDueDateFormat(item.due_date) }}</span
                  >
                </v-tooltip>
              </div>
            </div>
          </template>
          <!-- Priority -->
          <template v-slot:[`item.priority`]="{ item }">
            <div
              style="min-width: 100px"
              class="d-flex align-center justify-center"
            >
              <v-chip
                class="due_date-chip my-1 text-capitalize"
                small
                :id="`priority-${item.task_id}`"
                @click="openPriorityMenu($event, item)"
                :class="
                  item.assigned_by.id != getLoggedInUser.id &&
                  getSelectedCompany.role == 'employee'
                    ? ''
                    : 'pointer'
                "
                :color="
                  item.priority == 'high'
                    ? 'priority-red-chip-color red-chip-texts d-flex justify-center'
                    : item.priority == 'medium'
                    ? 'priority-orange-chip-color orange-chip-texts d-flex justify-center'
                    : item.priority == 'low'
                    ? 'priority-yellow-chip-color yellow-chip-texts d-flex justify-center'
                    : item.assigned_by.id != getLoggedInUser.id &&
                      getSelectedCompany.role == 'employee'
                    ? 'priority-blue-chip-color emp-status-blue-chip-text  d-flex  justify-center '
                    : 'priority-blue-chip-color status-blue-chip-text  d-flex justify-center  '
                "
              >
                {{
                  item.priority
                    ? item.priority
                    : item.assigned_by.id != getLoggedInUser.id &&
                      getSelectedCompany.role == "employee"
                    ? "No Priority"
                    : "Set priority"
                }}
              </v-chip>

              <v-tooltip
                :disabled="$vuetify.breakpoint.xs"
                :activator="`#priority-${item.task_id}`"
                content-class="arrow-up"
                open-delay="120"
                bottom
                color="#DCD8F3"
              >
                <span class="dark-purple-text font-weight-bold">Priority</span>
              </v-tooltip>
            </div>
          </template>
          <!-- Status -->
          <template v-slot:[`item.status`]="{ item }">
            <div class="d-flex align-center pointer justify-center px-0">
              <v-chip
                :id="'status-' + item.task_id"
                class="due_date-chip px-0 d-flex justify-center"
                small
                :class="
                  item.overdue && item.status != 'completed'
                    ? 'red-chip-color'
                    : item.status === 'active' && item.running
                    ? 'light-blue-chip-color'
                    : item.status === 'active' && !item.running
                    ? 'status-paused-chip-color'
                    : item.status === 'pending'
                    ? 'status-yellow-chip-color'
                    : item.status == 'completed' && item.archived_at != null
                    ? 'status-blue-chip-color'
                    : item.status === 'completed'
                    ? 'green-chip-color'
                    : ''
                "
              >
                <span class="text-capitalize">
                  <v-progress-circular
                    v-if="updateStatusLoader && setTaskId == item.task_id"
                    indeterminate
                    class="ml-1"
                    :size="17"
                    :width="1"
                  ></v-progress-circular>
                  <span v-else>
                    {{
                      item.overdue && item.status != "completed"
                        ? "Overdue"
                        : item.status === "pending"
                        ? "Pending"
                        : item.status === "completed" &&
                          item.archived_at != null
                        ? "Archived"
                        : item.status === "completed"
                        ? "Completed"
                        : item.status === "active" && item.running
                        ? "Active"
                        : item.status === "active" && !item.running
                        ? "Paused"
                        : ""
                    }}</span
                  >
                </span>
              </v-chip>
              <v-tooltip
                :disabled="$vuetify.breakpoint.xs"
                v-if="item.completed_at"
                :activator="'#' + 'status-' + item.task_id"
                content-class="arrow-up"
                bottom
                color="#DCD8F3"
              >
                <span class="dark-purple-text font-weight-bold">{{
                  getCompletedDateFormat(item.completed_at)
                }}</span>
              </v-tooltip>
            </div>
          </template>
          <!-- Durations -->
          <template class="px-0" v-slot:[`item.members.duration`]="{ item }">
            <div
              style="min-width: 100px"
              class="d-flex align-center justify-center body-2 px-0 pointer"
            >
              <v-menu
                v-if="getSelectedCompany.role != 'employee'"
                content-class="pa-0 bg-white"
                offset-y
                bottom
                width="600px"
                nudge-left="88px"
              >
                <template v-slot:activator="{ on }">
                  <div v-on="on">
                    <v-tooltip
                      :disabled="$vuetify.breakpoint.xs"
                      content-class="arrow-up"
                      bottom
                      down
                      color="#DCD8F3"
                    >
                      <template v-slot:activator="{ on }">
                        <div v-on="on">
                          {{
                            getActiveTask &&
                            getActiveTask.task_id == item.task_id
                              ? getMyDuration(item)
                              : getTotalDuration(item)
                          }}
                        </div>
                      </template>
                      <span class="dark-purple-text font-weight-bold">{{
                        "hh:mm:ss"
                      }}</span>
                    </v-tooltip>
                  </div>
                </template>

                <div
                  class="
                    left-pannel-bg-color
                    font-weight-bold
                    w-100
                    white--text
                    py-2
                    px-3
                  "
                >
                  Durations
                </div>
                <v-list class="overflow-scroll" scrollabe max-height="155">
                  <v-list-item
                    class="d-flex"
                    v-for="member in item.members"
                    :key="member.id"
                  >
                    <profileImage
                      inline
                      v-show="member.image ? ':src' : ':username'"
                      :src="member.image"
                      :username="member.name ? member.name : member.email"
                      :size="30"
                      :userProfile="true"
                      :circular="true"
                      class="my-2 text-light d-inline mr-2"
                    >
                    </profileImage>
                    <span
                      max-width="100px"
                      class="
                        d-inline-block
                        caption
                        text-capitalize text-truncate
                        mr-1
                      "
                    >
                      {{ member.name ? member.name : member.email }} :
                    </span>
                    <v-spacer></v-spacer>
                    <span class="caption d-inline-block">
                      {{
                        member
                          ? member.id == getLoggedInUser.id
                            ? getMyDuration(item)
                            : format(member.duration)
                          : ""
                      }}
                    </span>
                  </v-list-item>
                </v-list>
              </v-menu>
              <div v-else class="mr-2">
                {{ getTotalDuration(item) }}
              </div>
            </div>
          </template>
          <!-- Play/Pause actions -->
          <template v-slot:[`item.actions`]="{ item }">
            <div
              :style="isExtension ? 'min-width: 48px;width: 48px' : ''"
              class="d-flex align-center justify-end"
              :class="$vuetify.breakpoint.xs ? 'my-5' : ''"
              style="min-width: 110px"
            >
              <div
                :style="!isExtension ? 'min-width: 110px' : ''"
                class="d-flex align-center justify-center"
              >
                <!-- comment icon -->
                <v-badge
                  :content="
                    parseInt(item.comments_count) < 100
                      ? item.comments_count
                      : '99+'
                  "
                  v-show="item.comments_count"
                  color="green"
                  :class="[
                    { 'mr-3': parseInt(item.comments_count) > 100 },
                    { 'mr-2': parseInt(item.comments_count) > 9 },
                    {
                      'style-badge': item.assigned_by.id == getLoggedInUser.id,
                    },
                  ]"
                  overlap
                >
                  <img
                    :id="'comment-' + item.task_id"
                    @click="
                      getPendingTimer && getPendingTimer.task_id == item.task_id
                        ? () => {}
                        : openCommentModal(item)
                    "
                    height="24px"
                    width="24px"
                    class="dark-purple-text pointer mx-1"
                    :src="comment_icon"
                    alt="comment icon"
                  />
                </v-badge>
                <img
                  v-show="!item.comments_count"
                  @click="
                    getPendingTimer && getPendingTimer.task_id == item.task_id
                      ? () => {}
                      : openCommentModal(item)
                  "
                  height="24px"
                  width="24px"
                  class="dark-purple-text pointer mx-1"
                  :src="comment_icon"
                  alt="comment icon"
                />
                <!-- Flag Icon -->
                <v-tooltip
                  :disabled="$vuetify.breakpoint.xs"
                  content-class="arrow-up"
                  bottom
                  color="#DCD8F3"
                >
                  <template v-slot:activator="{ on }">
                    <div
                      v-on="on"
                      v-if="
                        getSelectedCompany.role != 'employee' ||
                        item.assigned_by.id == getLoggedInUser.id ||
                        item.is_flagged
                      "
                    >
                      <v-icon
                        v-show="!item.is_flagged"
                        @click.stop="
                          getSelectedCompany.role == 'employee' &&
                          item.assigned_by.id != getLoggedInUser.id
                            ? () => {}
                            : flagTask(item, true)
                        "
                        class="mx-1 pointer"
                        color="#2a206a"
                        size="23"
                        >mdi-bookmark-outline</v-icon
                      >
                      <v-icon
                        v-show="item.is_flagged"
                        @click.stop="
                          getSelectedCompany.role == 'employee' &&
                          item.assigned_by.id != getLoggedInUser.id
                            ? openSnackbar(true, 'Only assigner can flag task')
                            : flagTask(item, false)
                        "
                        class="mr-1 pointer"
                        size="23"
                        color="#D52A5D"
                        >mdi-bookmark</v-icon
                      >

                      <!-- <img
                        v-show="!item.is_flagged"
                        src="@/assets/images/Disabled Flag.svg"
                        height="16px"
                        class="mr-1 pointer"
                        @click.stop="
                          getSelectedCompany.role == 'employee' &&
                          item.assigned_by.id != getLoggedInUser.id
                            ? () => {}
                            : flagTask(item, true)
                        "
                      />
                      <img
                        v-show="item.is_flagged"
                        src="@/assets/images/Selected Flag .svg"
                        height="16px"
                        class="mr-1 pointer"
                        @click.stop="
                          getSelectedCompany.role == 'employee' &&
                          item.assigned_by.id != getLoggedInUser.id
                            ? openSnackbar(true, 'Only assigner can flag task')
                            : flagTask(item, false)
                        "
                      /> -->
                    </div>
                  </template>
                  <span class="dark-purple-text font-weight-bold">Flag</span>
                </v-tooltip>

                <div class="d-flex align-center" v-if="!isExtension">
                  <!---Make task Status Completed-------->
                  <v-tooltip
                    :disabled="$vuetify.breakpoint.xs"
                    content-class="arrow-up"
                    bottom
                    v-if="item.status != 'completed'"
                    color="#DCD8F3"
                  >
                    <template v-slot:activator="{ on }">
                      <v-icon
                        v-show="
                          item.assigned_by.id == getLoggedInUser.id ||
                          getSelectedCompany.role != 'employee'
                        "
                        color="#1cc283"
                        :disabled="
                          (setTaskId == item.task_id &&
                            disableStatusIcon == true) ||
                          (getSelectedCompany.role == 'employee' &&
                            item.assigned_by.id != getLoggedInUser.id)
                        "
                        v-on="on"
                        class="pointer ml-1"
                        @click.stop="
                          getPendingTimer &&
                          getPendingTimer.task_id == item.task_id
                            ? () => {}
                            : (setTaskId = item.task_id),
                            updateTaskStatus(item, 'completed')
                        "
                        >mdi-checkbox-blank-outline</v-icon
                      >
                    </template>
                    <span class="dark-purple-text font-weight-bold"
                      >Mark as Complete</span
                    >
                  </v-tooltip>
                  <!---Make task Status Incompleted-------->
                  <v-tooltip
                    :disabled="$vuetify.breakpoint.xs"
                    content-class="arrow-up"
                    bottom
                    v-if="item.status == 'completed'"
                    color="#DCD8F3"
                  >
                    <template v-slot:activator="{ on }">
                      <v-icon
                        v-on="on"
                        :disabled="
                          (setTaskId == item.task_id &&
                            disableStatusIcon == true) ||
                          (getSelectedCompany.role == 'employee' &&
                            item.assigned_by.id != getLoggedInUser.id)
                        "
                        color="#13865a "
                        class="pointer ml-1"
                        @click.stop="
                          (setTaskId = item.task_id), checkTaskStatus(item)
                        "
                        >mdi-checkbox-marked</v-icon
                      >
                    </template>
                    <span class="dark-purple-text font-weight-bold"
                      >Mark as Incomplete</span
                    >
                  </v-tooltip>
                  <!-- Delete task menu -->
                  <v-menu
                    v-if="
                      item.assigned_by.id == getLoggedInUser.id ||
                      getSelectedCompany.role != 'employee'
                    "
                    offset-y
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn icon small v-bind="attrs" v-on="on">
                        <v-icon color="#2a206a"> mdi-dots-vertical </v-icon>
                      </v-btn>
                    </template>
                    <div :class="isMac ? 'edited_scrollbar' : ''">
                      <v-list
                        max-height="200"
                        class="pointer pa-0"
                        width="110px"
                      >
                        <div
                          v-if="
                            item.assigned_by.id == getLoggedInUser.id ||
                            getSelectedCompany.role != 'employee'
                          "
                          @click="
                            selectTask(item);
                            openRepeatTaskDialog = true;
                          "
                          class="
                            d-flex
                            status-list-min-height
                            caption
                            listing-hover
                            pointer
                          "
                        >
                          <v-list-item-content
                            class="d-flex justify-start mx-2 py-0"
                          >
                            Repeat
                          </v-list-item-content>
                        </div>
                        <div
                          v-if="
                            item.assigned_by.id == getLoggedInUser.id ||
                            getSelectedCompany.role != 'employee'
                          "
                          @click="archiveTaskEntry(item)"
                          class="
                            d-flex
                            status-list-min-height
                            caption
                            listing-hover
                            pointer
                          "
                        >
                          <v-list-item-content
                            class="d-flex justify-start mx-2 py-0"
                          >
                            Archive
                          </v-list-item-content>
                        </div>
                        <div
                          class="
                            d-flex
                            status-list-min-height
                            caption
                            listing-hover
                            pointer
                          "
                          @click="readOrUnreadComment(item)"
                        >
                          <v-list-item-content
                            class="d-flex justify-start mx-2 py-0"
                          >
                            {{
                              item && item.comments_count == 0
                                ? "Mark as unread"
                                : "Mark as read"
                            }}
                          </v-list-item-content>
                        </div>
                        <div
                          v-if="
                            item.assigned_by.id == getLoggedInUser.id ||
                            getSelectedCompany.role != 'employee'
                          "
                          @click="deleteTaskEntry(item)"
                          class="
                            d-flex
                            status-list-min-height
                            caption
                            listing-hover
                            pointer
                          "
                        >
                          <v-list-item-content
                            class="d-flex justify-start mx-2 py-0"
                          >
                            Delete
                          </v-list-item-content>
                        </div>
                      </v-list>
                    </div>
                  </v-menu>
                </div>
              </div>

              <v-menu
                v-if="isExtension"
                content-class="bg-white"
                offset-y
                :close-on-content-click="false"
              >
                <!-- member btn for medium screens and up -->
                <template v-slot:activator="{ on }">
                  <v-icon color="" v-on="on">mdi-dots-vertical</v-icon>
                </template>
                <v-list class="pointer">
                  <div
                    @click="
                      getPendingTimer && getPendingTimer.task_id == item.task_id
                        ? () => {}
                        : openCommentModal(item)
                    "
                    class="py-2 px-3 listing-hover"
                  >
                    Add Comments
                  </div>
                  <div
                    @click="
                      getPendingTimer && getPendingTimer.task_id == item.task_id
                        ? () => {}
                        : (setTaskId = item.task_id),
                        updateTaskStatus(item, 'completed')
                    "
                    class="py-2 px-3 listing-hover"
                  >
                    Mark as completed
                  </div>
                  <div
                    @click="deleteTaskEntry(item)"
                    class="py-2 px-3 listing-hover"
                  >
                    Delete
                  </div>
                </v-list>
              </v-menu>
            </div>
          </template>
        </v-data-table>
      </div>
    </div>
    <!-- Pagination -->
    <div
      v-if="!getTasksSkeletonLoader"
      class="d-flex w-100 align-center mx-0 px-0 mt-3"
      :class="[
        { 'flex-column': $vuetify.breakpoint.xs },
        { 'px-4': !$vuetify.breakpoint.xs },
        $mq == 'miniMobilePhones'
          ? 'table-width-miniPhones'
          : isExtension
          ? 'table-width-extension'
          : $vuetify.breakpoint.md
          ? 'table-width-2'
          : $vuetify.breakpoint.xs || $vuetify.breakpoint.sm
          ? 'table-width-3'
          : getSidebarMini
          ? 'table-width-4'
          : 'table-width',
      ]"
    >
      <!-- For sm screens and above -->
      <div
        v-if="!$vuetify.breakpoint.xs"
        class="d-flex my-1 align-center"
        style="width: 95%"
      >
        <span
          :class="$vuetify.breakpoint.xs ? 'mb-1' : 'align-end '"
          class="ml-2 pagination-text-color d-flex"
        >
          View
        </span>
        <div
          :style="
            isExtension
              ? 'width: 65px'
              : $vuetify.breakpoint.xs
              ? 'width: 80px;'
              : 'width: 75px;'
          "
          class="pa-0 d-flex mx-1"
          :cols="$vuetify.breakpoint.xs || $vuetify.breakpoint.sm ? 2 : 1"
        >
          <v-select
            id="tasklist-pg-selector"
            style="display: inline-table"
            hide-details
            dense
            solo
            flat
            class="subtitle-2"
            :items="[5, 10, 25, 50, 100]"
            :value="getSearchedPerPage"
            @change="changePerPage"
          />
        </div>
        <!-- hidden on sm-screens -->
        <span
          class="d-none d-sm-flex pagination-text-color"
          :class="
            $vuetify.breakpoint.xs ? 'subtitle-2 my-2 ' : 'd-flex align-end'
          "
          >rows per page</span
        >
      </div>
      <v-spacer></v-spacer>
      <div
        :class="$vuetify.breakpoint.xs ? 'flex-column flex-column-reverse' : ''"
        class="
          d-flex
          justify-end
          align-center
          w-100
          mx-0
          px-0
          body-2
          dusty-purple-text
        "
      >
        <!-- hidden on xs-screens -->
        <v-menu offset-y>
          <template #activator="{ on: onMenu }">
            <v-tooltip
              :disabled="$vuetify.breakpoint.xs"
              color="#DCD8F3"
              top
              content-class="arrow-down"
            >
              <template #activator="{ on: onTooltip }">
                <v-btn
                  v-if="!$vuetify.breakpoint.xs"
                  class="
                    text-capitalize
                    dark-purple-text
                    mx-2
                    d-flex d-xs-flex
                    align-center
                    mr-3
                    mt-2
                    mb-2
                  "
                  outlined
                  text
                  small
                  v-on="{ ...onMenu, ...onTooltip }"
                >
                  <div>
                    <v-icon class="mx-1">mdi-printer</v-icon>
                  </div>
                </v-btn>
              </template>

              <span class="dark-purple-text font-weight-bold">Download</span>
            </v-tooltip>
          </template>
          <v-list class="pa-0 body-2">
            <v-list-item class="listing-hover pointer" @click="download('csv')">
              <img
                src="@/assets/images/Csv_icon.png"
                height="16px"
                class="mr-1"
              />
              <v-list-item-content>CSV</v-list-item-content>
            </v-list-item>
            <v-list-item class="listing-hover pointer">
              <img
                src="@/assets/images/Excel_icon.png"
                height="20px"
                class="mr-1"
              />
              <a
                class="dropdown-item black--text text-decoration-none"
                href="#"
              >
                <download-excel
                  :data="excelDownload.data"
                  :labels="excelDownload.labels"
                  :name="excelDownload.name"
                  worksheet="abc"
                  >Excel</download-excel
                >
              </a>
            </v-list-item>
          </v-list>
        </v-menu>
        <span
          :class="
            $vuetify.breakpoint.xs
              ? ' d-flex justify-center w-100 my-2 mx-1'
              : ''
          "
          class="pagination-text-color body-2"
        >
          Showing
          {{
            getTasksPagination && getTasksPagination.from
              ? getTasksPagination.from
              : 0
          }}-{{
            getTasksPagination && getTasksPagination.to
              ? getTasksPagination.to
              : 0
          }}
          of
          {{
            getTasksPagination && getTasksPagination.total
              ? getTasksPagination.total
              : 0
          }}
          {{
            $vuetify.breakpoint.lg || $vuetify.breakpoint.xl ? "entries" : ""
          }}
        </span>
        <v-pagination
          v-if="getTasksPagination"
          id="pagination"
          class="my-1"
          :value="getSearchedPage"
          :length="getTasksPagination.last_page"
          circle
          :total-visible="5"
          @input="fetchPage"
        ></v-pagination>
        <span
          class="mr-n4"
          v-show="
            $vuetify.breakpoint.md ||
            $vuetify.breakpoint.lg ||
            $vuetify.breakpoint.xl
          "
        >
          Go to:
          <input
            v-model="pageInput"
            @keydown.enter="fetchPage(pageInput)"
            type="number"
            class="
              dark-purple-text
              theme-border
              pagination-input
              mt-1
              pl-1
              mr-1
              rounded-sm
            "
          />
        </span>
      </div>
    </div>
    <!-- snackbar -->
    <SnackbarNew
      :snackbar.sync="snackbar"
      :snackbarError="snackbarError"
      :snackbarMessage="snackbarMessage"
    />
    <!-- Dialogs -->

    <!-- Repeat Task Dialog -->
    <RepeatTaskDialog
      :task="selectedTask"
      :openRepeatTaskDialog.sync="openRepeatTaskDialog"
    />

    <!-- Comment Dialog Box -->
    <template v-show="!isExtension && openCommentDialog">
      <CommentsDialogBox
        :openCommentDialog.sync="openCommentDialog"
        :taskDetails="details"
        :getTaskComments="getTaskComments"
        @newAddedMembers="emittedMembers"
      />
    </template>
    <!--- Add New Member Modal --->
    <AddMember
      @membersDone="setTempMembers([])"
      @membersTemp="setTempMembers"
      @close="dialog = false"
      :dialog.sync="dialog"
    />
  </div>
</template>

<script>
import JsonExcel from "vue-json-excel";
import { mapGetters } from "vuex";
import { tasksMixin } from "@/mixins/tasksMixin";
import { snackbarMixin } from "@/mixins/snackbarMixin";
import RepeatTaskDialog from "./RepeatTaskDialog.vue";

export default {
  name: "TaskList",
  props: ["headers"],

  mixins: [tasksMixin, snackbarMixin],
  data() {
    return {
      flagRow: false,
    };
  },
  components: {
    SnackbarNew: () => import("@/components/Includes/SnackbarNew"),
    AddMember: () => import("@/components/TeamMembers/AddMember"),
    profileImage: () => import("../Includes/ProfileImage"),
    CommentsDialogBox: () => import("./Comments/CommentsDialogBox_latest"),
    UserInfo: () => import("@/components/TeamMembers/UserInfo"),
    TaskEntries: () => import("./TaskEntries"),
    RepeatTaskDialog: () => import("./RepeatTaskDialog"),
    downloadExcel: JsonExcel,
  },

  computed: {
    ...mapGetters([
      "getSelectedCompany",
      "getLoggedInUser",
      "getTasks",
      "getScreenRecorderState",
    ]),
  },
  methods: {
    emittedMembers(members) {
      this.newAddedMembers = [...members];
    },
  },
};
</script>
<style scoped>
.back-click-color {
  background-color: red !important;
}
.bg-hover {
  background-color: #e5efff !important;
}
.bg-color {
  background-color: white !important;
}
.tooltip-opacity {
  opacity: 1 !important;
}
.project-name-on-hover:hover {
  text-decoration-line: underline;
  color: #6c5cd6 !important;
}
/* row per page css */
.inputContainer i {
  position: absolute;
}
.header-dropdown {
  color: #6c5cd6 !important;
  border: 1px #dad6f5 solid !important;
}
.date-range-dropdown {
  min-height: 25px;
  min-width: 150px;
}
.date-range-dropdown:hover {
  background-color: #e9fcf5;
}
.date-range-text-color {
  color: #757096;
  font-size: 12px;
  font-style: Roboto Medium;
}
.date-range-text-color:hover {
  color: #1cc283 !important;
}
/* show overlay when offline */
.divOverlay {
  position: absolute;
  left: 50%;
  bottom: 20%;
}
.expanding-chevron-bg {
  border: 1px solid #1cc283;
  background-color: rgba(28, 194, 131, 0.12);
}
.overlay-height {
  height: calc(100vh - 160px) !important;
  overflow: hidden;
  overflow-y: scroll;
}
.overlay-height-sm {
  height: calc(100vh - 140px) !important;
  overflow: hidden;
  overflow-y: scroll;
}
.listing-hover .v-list-item {
  min-height: 30px !important;
}
.v-table tr:hover:not(.v-table__expanded__content) {
  background: red !important;
}
.v-progress-linear {
  background: transparent;
  overflow: hidden;
  position: initial;
  transition: 0.2s cubic-bezier(0.4, 0, 0.6, 1);
  width: 100%;
}
.table-height-extn {
  height: 70vh;
}
.test-width {
  width: 275vh !important;
}
</style>
<style>
/* tbody tr:nth-of-type(even) {
  background-color: #ffff !important;
} */
.v-application--is-ltr .v-date-picker-title .v-picker__title__btn {
  text-align: left;
  font-size: 18px !important;
}
#task-page-due-date .v-date-picker-title {
  display: flex;
  justify-content: space-between;
  flex-direction: row-reverse;
  flex-wrap: wrap;
  line-height: 1;
}
#task-page-due-date .v-card__actions {
  align-items: center;
  display: contents !important;
  padding: 8px;
}
.style-badge .v-badge,
.v-badge__badge {
  display: inline-block;
  line-height: 1;
  margin-left: -4px;
}
.v-application .primary--text {
  color: #1cc283 !important;
  caret-color: #1cc283 !important;
}
.title-font {
  font-size: 0.9rem;
  letter-spacing: 0.009375em;
  font-weight: 500;
}

.task-table tbody tr:nth-of-type(even) {
  background-color: rgba(78, 78, 78, 0.05);
}
.v-text-field > .v-input__control > .v-input__slot:before {
  border-style: none !important;
}
.v-text-field > .v-input__control > .v-input__slot:after {
  border-style: none !important;
}
.v-input__slot {
  height: 22px !important;
}
</style>
